import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-14 pb-5 px-5" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "flex justify-between gap-4" }
const _hoisted_4 = { class: "flex justify-start gap-4" }
const _hoisted_5 = { class: "flex flex-col items-start" }
const _hoisted_6 = { class: "mb-1 flex flex-1 justify-between w-full" }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = { class: "text-xs" }
const _hoisted_9 = { class: "flex flex-col items-start w-120" }
const _hoisted_10 = { class: "mb-1 flex flex-1 justify-between w-full" }
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = { class: "flex flex-col items-start w-120" }
const _hoisted_13 = { class: "mb-1 flex flex-1 justify-between w-full" }
const _hoisted_14 = { class: "font-bold" }
const _hoisted_15 = { class: "flex flex-col items-start w-220" }
const _hoisted_16 = { class: "mb-1 flex flex-1 justify-between w-full" }
const _hoisted_17 = { class: "font-bold" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "px-2" }
const _hoisted_20 = { class: "mt-5 relative" }
const _hoisted_21 = { class: "flex justify-start mb-6 text-sm bg-gray-100 border mx-5 p-2 rounded text-gray-600" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode()
const _hoisted_23 = {
  key: 0,
  class: "absolute right-5 z-10"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("button", { id: "excel-export" }, null, -1)
const _hoisted_25 = { class: "px-2" }
const _hoisted_26 = { class: "text-center mb-4 font-bold text-black" }
const _hoisted_27 = { class: "mt-5 relative" }
const _hoisted_28 = {
  key: 0,
  class: "absolute right-5 z-10"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("button", { id: "excel-export-2" }, null, -1)
const _hoisted_30 = { class: "px-2" }
const _hoisted_31 = {
  key: 1,
  class: "text-center mb-4 font-bold text-black"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_vue_excel_xlsx = _resolveComponent("vue-excel-xlsx")!
  const _component_vue_echarts = _resolveComponent("vue-echarts")!
  const _component_NoChartDataPlaceholder = _resolveComponent("NoChartDataPlaceholder")!
  const _component_PeakHoursChart = _resolveComponent("PeakHoursChart")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_PageTitle, { title: "reports.hourlyDeliveryTimeAnalysis.title" })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('reports.darkStoreOrderPeakHours.dateRange')), 1),
              _createVNode(_component_Popper, {
                arrow: "",
                hover: "",
                placement: "auto"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('reports.darkStoreOrderPeakHours.dateRangeInfo')), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_BaseIcon, { name: "info" })
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_Datepicker, {
              range: "",
              "max-range": "7",
              "enable-time-picker": false,
              modelValue: _ctx.dateRange,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateRange) = $event)),
              format: 'dd.MM.yyyy',
              class: "w-full",
              placeholder: _ctx.$t('reports.darkStoreOrderPeakHours.dateRangePlaceholder')
            }, null, 8, ["modelValue", "format", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('reports.darkStoreOrderPeakHours.startHour')), 1)
            ]),
            _createVNode(_component_Multiselect, {
              canClear: false,
              modelValue: _ctx.startHour,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startHour) = $event)),
              options: _ctx.hours,
              label: "label",
              valueProp: "value",
              noOptionsText: _ctx.$t('reports.darkStoreOrderPeakHours.hourPlaceholder'),
              placeholder: _ctx.$t('08:00')
            }, null, 8, ["modelValue", "options", "noOptionsText", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('reports.darkStoreOrderPeakHours.endHour')), 1)
            ]),
            _createVNode(_component_Multiselect, {
              canClear: false,
              modelValue: _ctx.endHour,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endHour) = $event)),
              options: _ctx.hours,
              label: "label",
              valueProp: "value",
              noOptionsText: _ctx.$t('reports.darkStoreOrderPeakHours.hourPlaceholder'),
              placeholder: _ctx.$t('18:00'),
              class: "w-full"
            }, null, 8, ["modelValue", "options", "noOptionsText", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("label", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('reports.hourlyDeliveryTimeAnalysis.deliveryTimeApply')), 1)
            ]),
            _createVNode(_component_Multiselect, {
              canClear: false,
              modelValue: _ctx.deliveryTimeApply,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.deliveryTimeApply) = $event)),
              options: _ctx.deliveryTimeApplyItems,
              label: "label",
              valueProp: "id",
              noOptionsText: _ctx.$t('reports.darkStoreOrderPeakHours.hourPlaceholder'),
              placeholder: _ctx.$t('18:00'),
              class: "w-full"
            }, null, 8, ["modelValue", "options", "noOptionsText", "placeholder"])
          ]),
          _createElementVNode("button", {
            disabled: !(_ctx.dateRange && _ctx.startHour !== null && _ctx.endHour !== null ),
            class: "primary h-10 px-2 mt-6",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fetchReports && _ctx.fetchReports(...args)))
          }, [
            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('search')), 1)
          ], 8, _hoisted_18)
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_BaseIcon, {
            name: "info",
            class: "w-8"
          }),
          _hoisted_22,
          _createElementVNode("i", null, _toDisplayString(_ctx.$t('reports.hourlyDeliveryTimeAnalysis.slotInfoTitle')), 1)
        ]),
        (_ctx.deliveryTimeAnalysisReportForMoreThan1Mins.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createVNode(_component_vue_excel_xlsx, {
                data: _ctx.exportData,
                columns: _ctx.exportColumn,
                "file-name": _ctx.exportName,
                "file-type": 'xlsx',
                "sheet-name": 'sheetname'
              }, {
                default: _withCtx(() => [
                  _hoisted_24,
                  ((_ctx.dateRange && _ctx.startHour !== null && _ctx.endHour !== null))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "primary h-8 px-2",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.exportTableToExcel($event)))
                      }, [
                        _createVNode(_component_BaseIcon, { name: "file-white" }),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('export')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["data", "columns", "file-name"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('reports.hourlyDeliveryTimeAnalysis.subTitle')), 1),
        (this.deliveryTimeAnalysisReportForMoreThan1Mins.length)
          ? (_openBlock(), _createBlock(_component_vue_echarts, {
              key: 1,
              style: {"height":"400px"},
              option: _ctx.chartOptionTimeAnalysis
            }, null, 8, ["option"]))
          : (_openBlock(), _createBlock(_component_NoChartDataPlaceholder, { key: 2 }))
      ]),
      _createElementVNode("div", _hoisted_27, [
        (_ctx.deliveryPeakHoursReport.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createVNode(_component_vue_excel_xlsx, {
                data: _ctx.exportData,
                columns: _ctx.exportColumn,
                "file-name": _ctx.exportName,
                "file-type": 'xlsx',
                "sheet-name": 'sheetname'
              }, {
                default: _withCtx(() => [
                  _hoisted_29,
                  ((_ctx.dateRange && _ctx.startHour !== null && _ctx.endHour !== null))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "primary h-8 px-2",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.exportPeakHoursTableToExcel($event)))
                      }, [
                        _createVNode(_component_BaseIcon, { name: "file-white" }),
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('export')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["data", "columns", "file-name"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.$t('reports.darkStoreOrderPeakHours.subTitle')), 1)),
        (_ctx.deliveryPeakHoursReport.length)
          ? (_openBlock(), _createBlock(_component_PeakHoursChart, {
              key: 2,
              ref: "peakHoursChart"
            }, null, 512))
          : (_openBlock(), _createBlock(_component_NoChartDataPlaceholder, {
              key: 3,
              class: "mb-8"
            }))
      ])
    ])
  ]))
}